class ApiError extends Error {
    constructor(message, errorKey = undefined, apiMessage = undefined) {
        super(message);
        this.errorKey = errorKey;
        this.apiMessage = apiMessage;
    }
}

export default ApiError;
